const PORTAL_ROOT_URL = import.meta.env.VITE_APP_ROOT_URL;

/**
 * Resolves a mandator portal link (login, registration, logout, account
 * deletion) against the portal origin, `VITE_APP_ROOT_URL`.
 *
 * Mandators may configure these as paths (`/user/login`). A bare path resolves
 * against the app's own origin, which only works where the portal and the app
 * share a host or a proxy — ariva dev serves the app on
 * `portfolio.ariva.localhost` while the portal lives on `ariva.localhost`.
 * Absolute URLs are returned unchanged.
 */
export const resolvePortalUrl = (url?: string): string | undefined => {
  if (!url || !PORTAL_ROOT_URL) {
    return url;
  }

  try {
    return new URL(url, PORTAL_ROOT_URL).toString();
  } catch {
    return url;
  }
};
